import { EventEmitter } from 'events';
import { BannerType } from '@fluidx/office-fluid-types';
import { defaultLocale } from '@fluidx/utilities';
import { GenericEvent } from './telemetry/GenericEvent';
import { getStringTable } from './localizationUtilities';
import { sendTelemetryEvent } from '@fluidx/telemetry';
// TODO: Do we need multi line support in Message Banner for DLP?
// TODO: Update styling and icon
/**
 * A message banner provider that produces banners for Data Loss Protection
 */ export class InformationProtectionBannerProvider extends EventEmitter {
    get MessageBannerProvider() {
        return this;
    }
    dispose() {
        this.removeAllListeners();
    }
    async initializeStringTable() {
        this.informationProtectionStringTable = await getStringTable(this.locale || defaultLocale);
    }
    constructor(informationProtectionService, resolvedUrl, locale, logger){
        super();
        this.informationProtectionService = informationProtectionService;
        this.resolvedUrl = resolvedUrl;
        this.locale = locale;
        this.logger = logger;
        this.checkDlpPolicyTip = async ()=>{
            const dlpPolicyTip = await this.informationProtectionService.getDlpTooltip(this.resolvedUrl);
            if (dlpPolicyTip) {
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                this.dlpHandler(dlpPolicyTip);
            }
        };
        this.dlpHandler = async (tip)=>{
            if (!this.informationProtectionStringTable) {
                this.informationProtectionStringTable = await getStringTable(this.locale || defaultLocale);
            }
            this.logger && sendTelemetryEvent(this.logger, {
                eventName: GenericEvent.DlpTooltipBannerCreated
            });
            this.emit('CreateBanner', {
                bannerId: 'DLPPolicyTip',
                bannerType: BannerType.info,
                bannerStrings: {
                    bannerMessage: tip.generalText
                },
                bannerLink: tip.complianceUrl ? {
                    title: this.informationProtectionStringTable.sensitivityButtonLearnMoreLinkText,
                    url: tip.complianceUrl
                } : {}
            });
        };
        this.mandatoryLabelHandler = async ()=>{
            if (!this.informationProtectionStringTable) {
                this.informationProtectionStringTable = await getStringTable(this.locale || defaultLocale);
            }
            this.logger && sendTelemetryEvent(this.logger, {
                eventName: GenericEvent.MandatoryLabelingBannerCreated
            });
            this.emit('CreateBanner', {
                bannerId: 'MandatoryLabelRequired',
                bannerType: BannerType.info,
                bannerStrings: {
                    bannerMessage: this.informationProtectionStringTable.mandatoryLabelingMessage
                },
                actions: [
                    {
                        label: this.informationProtectionStringTable.mandatoryLabelActionButtonText,
                        actionCallback: ()=>{
                            this.informationProtectionService.emit('openLabelPicker');
                        }
                    }
                ]
            });
        };
        this.sensitivityLabelChangedHandler = async (newLabel)=>{
            if (newLabel) {
                this.logger && sendTelemetryEvent(this.logger, {
                    eventName: GenericEvent.MandatoryLabelingBannerRemoved
                });
                this.emit('RemoveBanner', 'MandatoryLabelRequired');
                this.logger && sendTelemetryEvent(this.logger, {
                    eventName: GenericEvent.SensitivityErrorBannerRemoved
                });
                this.emit('RemoveBanner', 'SensitivityError');
            }
        };
        this.errorHandler = async ()=>{
            if (!this.informationProtectionStringTable) {
                this.informationProtectionStringTable = await getStringTable(this.locale || defaultLocale);
            }
            this.logger && sendTelemetryEvent(this.logger, {
                eventName: GenericEvent.SensitivityErrorBannerCreated
            });
            this.emit('CreateBanner', {
                bannerId: 'SensitivityError',
                bannerType: BannerType.error,
                bannerStrings: {
                    bannerMessage: this.informationProtectionStringTable.setLabelError
                }
            });
        };
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.initializeStringTable();
        this.informationProtectionService.on('dlpPolicyTip', this.dlpHandler);
        this.informationProtectionService.on('mandatoryLabelRequired', this.mandatoryLabelHandler);
        this.informationProtectionService.on('sensitivityLabelChanged', this.sensitivityLabelChangedHandler);
        this.informationProtectionService.on('sensitivityError', this.errorHandler);
        this.once('BannerListenerAttached', async ()=>{
            // call enforceMandatoryLabelExperience to trigger mandatory label banner if appropriate
            this.informationProtectionService.enforceMandatoryLabelExperience(resolvedUrl);
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.checkDlpPolicyTip();
        });
    }
}
